import axios from "axios/index";
axios.defaults.paramsSerializer = params => transformRequestOptions(params);

/**
 *
 * @param url
 * @param requestOptions
 * @returns {*}
 * @constructor
 */
function POST(url, requestOptions){
    return baseForRequestType(url, 'POST', requestOptions);
}

/**
 *
 * @param url
 * @param requestOptions
 * @returns {*}
 * @constructor
 */
function PUT(url, requestOptions){
    return baseForRequestType(url, 'PUT', requestOptions);
}

/**
 *
 * @param url
 * @param requestOptions
 * @returns {*}
 * @constructor
 */
function DELETE(url, requestOptions){
	return baseForRequestType(url, 'DELETE', requestOptions);
}

/**
 *
 * @param url
 * @param requestOptions
 * @returns {*}
 * @constructor
 */
function GET(url, requestOptions){
	return baseForRequestType(url, 'GET', requestOptions);
}

/**
 * Обертка для формирования разных типов запросов
 * @param url
 * @param type
 * @param requestOptions
 * @returns {*}
 */
function baseForRequestType(url, type, requestOptions){
		let ajaxSetup = _getAjaxSetup(url,type,requestOptions);
		return _doRequest(ajaxSetup);
}

function transformRequestOptions(params){
    let options = '';
    for (const key in params) {
        if (typeof params[key] !== 'object') {
            options += `${key}=${params[key]}&`;
        } else if ( Array.isArray(params[key]) ) {
            params[key].forEach(el => {
                options += `${key}=${el}&`;
            });
        }
    }
    return options ? options.slice(0, -1) : options;
}
/**
 *
 * @param url
 * @param requestType
 * @param requestOptions
 * @returns {{method: (*|string), url: *, responseType: (*|string), headers: ({}|*|{"content-type": string}), data: *}}
 * @private
 */
function _getAjaxSetup(url, requestType, requestOptions) {
	requestOptions = requestOptions || {};
    return {
        baseURL: 'https://iqdesk.ru',
        method: requestType || 'GET',
        url: url,
        responseType: requestOptions.dataType || 'json',
        headers: requestOptions.headersObj || {
          'content-type': "application/json; charset=utf-8",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        },
        data: requestOptions.data,
        params:requestOptions.params,
		cancelToken: requestOptions.cancelToken
    };
}

/**
 *
 * @param ajaxSetup
 * @returns {AxiosPromise}
 * @private
 */
function _doRequest(ajaxSetup) {
	return axios(ajaxSetup);
}

export default {
	POST,
    GET,
    DELETE,
    PUT,
	cancelToken: axios.CancelToken
};
